import Vue from 'vue';
import Vuex from 'vuex';
import appointment from './modules/appointment';
import locations from './modules/locations';
import rolexTrackingModule from './modules/rolexTrackingStoreModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    appointment,
    locations,
    rolexTracking: rolexTrackingModule
  },
  strict: process.env.NODE_ENV !== 'production'
});